import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger'

import comments from './reducers/comments';
import features from './reducers/features';
import instances from './reducers/instances';
import likes from './reducers/likes';
import media from './reducers/media';
import player from './reducers/player';
import snippets from './reducers/snippets';
import ui from './reducers/ui';
import user from './reducers/user';

import { setPlayerLoaded } from './actions/player';
import { watchSessionExpiry } from './actions/ui';

const rootReducer = combineReducers({
	comments,
	features,
	instances,
	likes,
	media,
	player,
	snippets,
	ui,
	user
});

var store = {};

if (window.commentstate && window.commentstate.ui && window.commentstate.ui.debug) {
	const loggerMiddleware = createLogger();
	store = createStore(rootReducer,
		applyMiddleware(
			thunkMiddleware, // lets us dispatch() functions,
			loggerMiddleware // neat middleware that logs actions
		)
	);
}
else {
	store = createStore(rootReducer,
		applyMiddleware(
			thunkMiddleware, // lets us dispatch() functions
		)
	);
}

window.onPlayerInit = (player)=>store.dispatch(setPlayerLoaded(player));
store.dispatch(watchSessionExpiry());

export default store;